import React from 'react';
import { useColorScheme } from 'react-native';
import { ThemeContext } from '.';
import { themes } from '../components/layout/theme';

/**
 * @description Theme provider for the app
 * @param {React.PropsWithChildren} props
 * @return {React.FC}
 */
export const ThemeProvider: React.FC<React.PropsWithChildren> = (props) => {
  const systemColorScheme = useColorScheme();
  const theme = systemColorScheme === 'dark' ? themes.dark : themes.light;

  return <ThemeContext.Provider value={{ theme }}>{props.children}</ThemeContext.Provider>;
};
